import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import SunnyIcon from '@mui/icons-material/Sunny';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Edicion from './Edicion';

export default function Dia({ config, programa }) {

  return (
    <Box>
      <Edicion config={config} programa={programa} />
    </Box>
  );
}